import { UserLoginCard } from "@/features/session/components/UserLoginCard";
import { Stack } from "@mui/material";

const UserSelectPage = () => {
  return (
    <Stack alignItems="center">
      <UserLoginCard sx={{ width: "100%", maxWidth: 720 }} />
    </Stack>
  );
};

export default UserSelectPage;
